/* eslint-disable no-unused-vars */
import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import {
  getAllGoodsInData,
  getAllGoodsInDataLoading,
  setRightSideBarOpenCloseValue,
  setSelectedProjectDropdownValue,
  getGoodsInSingleData,
  getGoodsInRemarksData,
  addNewGoodsInData,
  setAllFilterDataToRedux,
  getAllGoodsInData1,
} from "src/thunks/goodsin";

const initialState = {
  loading: false,
  goodsinLoadingState: false,
  getByIdGoodsinLoadingState: false,
  addNewGoodsInLoading: false,
  rightSideBarOpenCloseValue: "",

  selectedClientDropdownValue: { id: 0, name: "ALL CLIENTS" },
  selectedDepotDropdownValue: { id: 0, name: "ALL DEPOTS" },
  selectedProjectDropdownValue: { id: 0, name: "ALL PROJECTS" },
  selectedFromDateValue: new Date(),
  selectedToDatevalue: null,
  selectedPrevDateFlagvalue: false,
  selectedFromDateValueForDashboard: "",
  selectedToDatevalueForDashboard: moment().format("YYYY-MM-DD"),
  selectedReportObject: {},

  allGoodInData: [],
  goodsData: {},

  filterAllData: JSON.parse(localStorage.getItem("filterAllData")) || {}
};

const goodsinSlice = createSlice({
  name: "goodsinSlice",
  reducers: {},
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(setAllFilterDataToRedux, (state, action) => {
        state.filterAllData = action.payload; // networkConnectivity
      })

      .addCase(setRightSideBarOpenCloseValue, (state, action) => {
        state.rightSideBarOpenCloseValue = action.payload; // networkConnectivity
      })

      .addCase(setSelectedProjectDropdownValue, (state, action) => {
        state.selectedProjectDropdownValue = action.payload;
      })

      .addCase(getAllGoodsInData.pending, (state, action) => {
        state.goodsinLoadingState = true;
      })
      .addCase(getAllGoodsInData.fulfilled, (state, action) => {
        state.goodsinLoadingState = false;
        state.allGoodInData = action.payload;
      })
      .addCase(getAllGoodsInData.rejected, (state, action) => {
        state.goodsinLoadingState = false;
      })
      .addCase(getAllGoodsInData1.pending, (state, action) => {
        state.goodsinLoadingState = true;
      })
      .addCase(getAllGoodsInData1.fulfilled, (state, action) => {
        state.goodsinLoadingState = false;
        state.allGoodInData = action.payload;
      })
      .addCase(getAllGoodsInData1.rejected, (state, action) => {
        state.goodsinLoadingState = false;
      })

      .addCase(getAllGoodsInDataLoading.pending, (state, action) => {
      })
      .addCase(getAllGoodsInDataLoading.fulfilled, (state, action) => {
        state.allGoodInData = [...state.allGoodInData, ...action?.payload]
      })
      .addCase(getAllGoodsInDataLoading.rejected, (state, action) => {
      })

      .addCase(addNewGoodsInData.pending, (state, action) => {
        state.addNewGoodsInLoading = true;
      })
      .addCase(addNewGoodsInData.fulfilled, (state, action) => {
        state.addNewGoodsInLoading = false;
        // state.allGoodInData = action.payload;
      })
      .addCase(addNewGoodsInData.rejected, (state, action) => {
        state.addNewGoodsInLoading = false;
      })

      .addCase(getGoodsInSingleData.pending, (state, action) => {
        state.getByIdGoodsinLoadingState = true;
      })
      .addCase(getGoodsInSingleData.fulfilled, (state, action) => {
        state.getByIdGoodsinLoadingState = false;
        state.goodsData = action.payload;
      })
      .addCase(getGoodsInSingleData.rejected, (state, action) => {
        state.getByIdGoodsinLoadingState = false;
      })
  },
});

export default goodsinSlice;
